export default "__VITE_ASSET__bafb6fbf__"